import { get } from '@/plugins/http'

export default {
  getCoursePosters: get('/live/api/v1/file/poster'),
  getCourseFiles: get('/live/api/v1/outer/file/seaFile/list/{courseId}'),
  downloadCourseFile: get('/api/v1/outer/file/seaFile/download/{courseId}'),
}
